import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

// 原始接口
export interface UserMaterialListFoldersResponse {
  total: number;
  list: MaterialFolderData[];
  page: number;
  size: number;
};

export interface MaterialFolderData {
  id: number;
  folder_uuid: string;
  parent_folder_id: number;
  user_id: number;
  folder_name: string;
  create_time: number;
  update_time: number;
  deleted_time?: string;
  show_pic?: string;
  related_agents?: { agent_id: number; type: number }[];
};


// 请求接口
interface UserMaterialListFoldersRequest {
  page: number,
  pageSize: number
  userId?: string
  agentId?: string,
}

export class UserMaterialFolderRelatedAgentData {
  @Required("Type cannot be empty")
  @IsNumber("Type must be a number")
  type: number;
}

export class UserMaterialFolderData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder name cannot be empty")
  @IsString("Folder name must be a string")
  folderName: string;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;

  // @Required("Item count cannot be empty")
  @IsNumber("folderItemsCount count must be a number")
  folderItemsCount?: number;

  @IsString("Show pic must be a string")
  showPic?: string;

  @IsArray("Related agents must be an array")
  @ValidateNested(UserMaterialFolderRelatedAgentData)
  relatedAgents?: UserMaterialFolderRelatedAgentData[];
}

export class UserMaterialListFoldersData {
  @IsArray("List must be an array")
  list: UserMaterialFolderData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  size: number;
}

const transformAndValidateAgent = (
  response: UserMaterialListFoldersResponse
): UserMaterialListFoldersData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UserMaterialListFoldersData);
  } catch (error) {
    console.error("User material list folders data validation failed:", error.message);
    throw error;
  }
};

/** 素材文件夹列表 */
export const userMaterialListFolders = async ({
  page,
  pageSize,
  userId,
  agentId,
}: UserMaterialListFoldersRequest): Promise<UserMaterialListFoldersData> => {
  const response = await apiV2.post<UserMaterialListFoldersResponse>('/user_material/list_folders', {
    page,
    page_size: pageSize,
    user_id: userId,
  }, {
    headers: {
      "X-Agent-Id": agentId,
    },
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
